<div *ngIf="isInProgress">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                <li class="breadcrumb-item active">Sales Report</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <div class="row mr-1">
      <div class="col-md-11">
        <form [formGroup]="form" (ngSubmit)="filterByDate()" class="form-inline">
          <div class="form-group">
              <label>From:<span style="color:red;">*</span></label>&nbsp;&nbsp;
              <input type="date" formControlName="date_from" class="form-control" placeholder="Date From" value="">
              <span *ngIf="submitted && form.get('date_from')?.hasError('required')" style="color:red"> <strong>Please enter or select starting date!</strong></span>
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div class="form-group">
              <label>To:<span style="color:red;">*</span></label>&nbsp;&nbsp;
              <input type="date" formControlName="date_to" class="form-control" placeholder="Date To" value="">
              <span *ngIf="submitted && form.get('date_to')?.hasError('required')" style="color:red"> <strong>Please enter or select ending date!</strong></span>
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div class="form-group">
              <button type="submit" class="btn btn-outline-success"><i class="fas fa-filter" aria-hidden="true">&nbsp;</i>Filter By Date</button>
          </div>
      </form>
      </div>
      <div class="col-md-1">
        <div class="row">
          <button type="submit" class="btn btn-success" (click)="exportToPdf()"><i class="fa fa-file-pdf" aria-hidden="true">&nbsp;</i>Export to PDF</button>
        </div>
      </div>
    </div>
  </section>
      <!-- /.content-header -->
  <section class="content">
    <div class="container-fluid" id="pspdfkit-container" style="width: 100%; height: 100vh">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title text-center w-100"><b>Sales Report for the period from {{ startDate | date: 'dd-MM-yyyy' }} to {{ endDate | date: 'dd-MM-yyyy' }} </b></h3>
        </div>
        <!-- /.card-header -->
        <div class="card-body" style="overflow-x: auto; overflow-y: auto; white-space: nowrap; height: 850px;">
          <!--Error messages here-->
          <table id="salesTable" class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Chassis No.</th>
                  <th>Year</th>
                  <th>Date Received</th>
                  <th>Duration In Stock</th>
                  <th>Date Sold</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of sales">
                <td>{{row.make}}</td>
                <td>{{row.model}}</td>
                <td>{{row.chassis_no}}</td>
                <td>{{row.yr_of_mfg}}</td>
                <td>{{row.date_received | date: 'dd-MM-yyyy'}}</td>
                <td>{{row.days_in_stock}}</td>
                <td>{{row.date_sold | date: 'dd-MM-yyyy'}}</td>
              </tr>
              <tr>
                <td colspan="6"></td>
                <td><b>Total Units Sold: {{ totalUnitsSold }}</b></td>
              </tr>
            </tbody>
          </table>
          <br>
          <h3><b><i>Summary</i></b></h3>
          <table id="summaryTable" class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Units Sold</th>
                  <th>Units In Stock</th>
                  <th>Units At CFS</th>
                  <th>Units On the way</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of salesByModel">
                <td>{{row.make}}</td>
                <td>{{row.model}}</td>
                <td>{{row.units_sold}}</td>
                <td>{{ row.units_in_stock }}</td>
                <td>{{ row.units_at_cfs }}</td>
                <td>{{ row.units_on_the_way }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.card-body -->
      </div>
    </div>
  </section>
